// extracted by mini-css-extract-plugin
export default {"logoContainerBlk":"Logo_logoContainerBlk__SV49y"};